<div
  class="modal-root-mobile-full"
  (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"
>
  <modal-header
    [title]="title"
    [showBackButton]="!isEditMode"
    (onBackClicked)="onBackClicked()"
  ></modal-header>

  <div class="modal-body">
    <app-account-form
      [isEditMode]="isEditMode"
      [inWizard]="data.isWizard"
      [accountType]="accountType"
      [currency]="currency()"
      (selectCurrency)="selectCurrency($event)"
      [selectedInstitution]="selectedInstitution()"
      [institutionInputOptions]="institutionInputOptions"
      [institutionNames]="institutionNames()"
      [countryNames]="countryNames()"
      [selectedCountryName]="selectedCountryName()"
      [countryCodes]="countryCodes()"
      [selectedInstitutionName]="selectedInstitutionName()"
      [taggedManualInstitutions]="taggedManualInstitutions()"
      [institutionSearchPlaceholder]="institutionPlaceholder()"
      [institutionsIsRefreshing]="institutionsIsRefreshing()"
      (institutionSelected)="setInstitution($event)"
      (institutionCleared)="clearInstitution()"
      (countrySelected)="onCountrySelected($event)"
      (addInstitutionClicked)="addInstitution()"
      [selectedAccountProduct]="selectedAccountProduct"
      (selectAccountProduct)="onSelectAccountType($event)"
      [saveButtonOptions]="saveButtonOptions"
      [accountNamePlaceHolder]="accountNamePlaceHolder()"
      [accountName]="accountName"
      [accountNickname]="accountNickname"
      (accountNameChanged)="accountNameSet($event)"
      (accountNicknameChanged)="accountNicknameSet($event)"
      (cancel)="cancel()"
      (create)="submitNext()"
    ></app-account-form>
  </div>
</div>
